import React, { useState, useMemo } from 'react';
import { useGetDealerPackageDropdownQuery } from '../../../../../../api/endpoints/compound';
import { MultiSelect } from 'primereact/multiselect';

const DealerPackageDropdown = ({ value, onChange, className, disabled, placeholder }) => {
    const [searchText, setSearchText] = useState('');

    const { data: packageList = [], isLoading } = useGetDealerPackageDropdownQuery({
        pageSize: 100,
        searchText: searchText
    });

    const packageOptions = useMemo(() => {
        return packageList.map((pkg) => ({
            id: pkg.id,
            text: pkg.text || pkg.name || pkg.translatedText || '',
            displayValue: pkg.text || pkg.name || pkg.translatedText || String(pkg.id)
        }));
    }, [packageList]);

    return (
        <MultiSelect
            disabled={disabled}
            value={value || []}
            options={packageOptions}
            onChange={(e) => onChange(e.value)}
            optionLabel="displayValue"
            optionValue="id"
            display="chip"
            showClear
            filter
            filterBy="displayValue"
            onFilter={(e) => setSearchText(e.filter)}
            className={className}
            placeholder={placeholder || 'Bayi Paketlerini Seçiniz'}
            loading={isLoading}
            itemTemplate={(option) => <div>{option.text}</div>}
        />
    );
};

export default DealerPackageDropdown;
